import localForage from 'localforage';
import Vue from 'vue';

export default {
	state() {
		return {
			cid: '',
			name: '',
			email: '',
			//
			roomList: [], // FRIEND LIST
			// privateRoomList: [], // PRIVATE CHAT
			// groupRoomList: [], // GROUP CHAT
			selectedRoom: null, // SELECT ROOM/FRIEND
			//
			messageList: [],
			// 
			pageName: '/PRELOAD',// /FRIEND, /SEARCH, /LOGIN, /PRELOAD /MESSAGE
			// 1. CHAT INPUT TEXT
			inputText: null,
			// 2. TEMP ROOM PREPARE TO ADD NEW FRIEND
			tempRoom: null, 
			// CHAT DIMENSION
			ui: {
				chatH: 600,
				titleH: 72,
				gapH: 16,
				friendW: 384, //w-96
			},
			// RUN AS COMPONENT
			widget: false,
		}
	},
	actions: {
		// USER PROFILE
		loadUserData({commit}) {
			return new Promise(async(resolve, reject) => {
				const userData = await localForage.getItem('userdata');
				if (userData && userData.cid) {
					commit('setProfile', userData);
					return resolve(userData);
				}

				return reject({message: 'userdata not found'});
			});
		},
		saveUserData({commit}, userData) {
			return new Promise(async(resolve, reject) => {
				await localForage.setItem('userdata', userData);
				commit('setProfile', userData);
				return resolve(true);
			});
		},
		removeUserData({commit}) {
			return new Promise(async(resolve, reject) => {
				await localForage.removeItem('userdata');
				commit('resetProfile');
				return resolve(true);
			});
		},
		// ROOM
		loadSelectedRoom({commit}) {
			return new Promise(async(resolve, reject) => {
				const roomData = await localForage.getItem('selectedroom');
				if (roomData && roomData.cid) {
					commit('setSelectedRoom', roomData);
					return resolve(roomData);
				}

				return reject({message: 'roomData not found'});
			});
		},
		saveSelectedRoom({commit}, roomData) {
			return new Promise(async(resolve, reject) => {
				await localForage.setItem('selectedroom', roomData);
				commit('setSelectedRoom', roomData);
				return resolve(true);
			});
		},
		removeSelectedRoom({commit}) {
			return new Promise(async(resolve, reject) => {
				await localForage.removeItem('selectedroom');
				commit('resetSelectedRoom');
				return resolve(true);
			});
		},
	},
	mutations: {
		// USER PROFILE
		setProfile(state, {cid, name, email}) {
			state.cid = cid;
			state.name = name;
			state.email = email;
		},
		resetProfile(state) {
			state.cid = '';
			state.name = '';
			state.email = '';
		},
		// SELECTED ROOM
		setSelectedRoom(state, room) {
			state.selectedRoom = room;
		},
		resetSelectedRoom(state) {
			state.selectedRoom = null;
		},
		// FRIEND LIST
		/*
			└── ROOM/
			    ├── userCid
			    ├── roomCid
			    ├── roomName
			    ├── roomEmail
			    ├── unread
			    ├── status
			    ├── roomType
			    ├── roomUserCid
			    ├── lastMessage
			    └── myLastMessageDate
		*/
		setRoomList(state, roomList) {
			state.roomList = roomList;
		},
		// setPrivateRoomList(state, roomList) {
		// 	state.privateRoomList = roomList;
		// },
		// setGroupRoomList(state, roomList) {
		// 	state.groupRoomList = roomList;
		// },
		updateRoom(state, room) {
        	const index = _.findIndex(state.roomList, {roomCid: room.roomCid});
        	if (index < 0) return;
        	Vue.set(state.roomList, index, room);
		},
		updateRoomField(state, {roomCid, fieldName, fieldValue}) {
        	const index = _.findIndex(state.roomList, {roomCid});
        	if (index < 0) return;
        	var room = state.roomList[index];
        	room[fieldName] = fieldValue;
        	Vue.set(state.roomList, index, room);
		},	
		addRoom(state, room) {
        	const index = _.findIndex(state.roomList, {roomCid: room.roomCid});
        	// IF ROOM EXIST THEN SKIP
        	if (index > -1) return;
			state.roomList.push(room);
		},
		// MESSAGE
		setMessageList(state, messageList) {
			state.messageList = messageList;
			this.$signals.signal.emit('scrollToBottom', {anime: false});
		},
		appendMessageList(state, messageList) {
			state.messageList = messageList.concat(state.messageList);
		},
		addMessage(state, message) {
			state.messageList.push(message);
			this.$signals.signal.emit('scrollToBottom', {anime: true});
		},
		resetMessageList(state) {
			state.messageList.splice(0, state.messageList.length);
		},
		removeMessage(state, message) {
        	state.messageList = state.messageList.filter(element => {
        		return element.groupCid != message.groupCid;
        	});
		}, 
		// updateMessageDateTime(state, str) {
		// 	if (state.messageList && state.messageList.length > 0) {
		// 		state.messageList.forEach(element => {
		// 			element.myCreatedDate = this.$signals.convertToHumanize(element.created_at);
		// 		});
		// 	}
		// },
		// PAGE STATUS
		setPageName(state, pageName) {
			// console.log('setPageName >>', pageName);
			state.pageName = pageName;
		},
		// INPUT TEXT
		// setInputText(state, inputText) {
		// 	state.inputText = inputText;
		// },
		/*
			└── TEMP ROOM/
			    ├── userCid
			    ├── roomCid
			    ├── roomName
			    ├── roomEmail
			    ├── unread
			    ├── status
			    ├── roomType
			    └── roomUserCid
		*/
		setTempRoom(state, tempRoom) {
			state.tempRoom = tempRoom;
		},
		resetTempRoom(state) {
			state.tempRoom = null;
		},
		//
		setWidget(state, widget) {
			state.widget = widget;
		},
	},
	getters: {
		privateRoomList(state) {
			const items = state.roomList.filter(element => element.roomType == 'private').map(obj => ({
			    ...obj,
			    lastMessageTimestamp: new Date(obj.lastMessageDate).getTime() // Add a timestamp property
			}));

			return _.orderBy(items, ["lastMessageTimestamp"], ["desc"]);
		},
		groupRoomList(state) {
			return state.roomList.filter(element => (element.roomType == 'public' && element.roomName != 'GLOBAL_LOBBY_ROOM_168168'));
		},
		contentH(state) {
			return { height: (state.ui.chatH - state.ui.titleH - state.ui.gapH) + `px` };
		},
		sidebarW(state) {
			return { width: state.ui.friendW + `px` };
		},
		globalRoom(state) {
			let res = null;
			state.roomList.every(element => {
				if (element.roomType == 'public' && element.roomName == 'GLOBAL_LOBBY_ROOM_168168') {
					res = element;
					return false;
				}
				return true;
			});
			return res;
		},
	},
}